const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/reducers/kompendiumReducer.ts';
import Imm from 'immutable';
import { KisLoggerService } from '../services/KisLoggerService';
import { incCounter, decCounter } from '../utils/reducerUtils';
import { LOAD_KOMPENDIUM_PARAGRAPHS, ILoadKompendiumParagraphsAction } from '../actions/kompendiumActions';

const Log = KisLoggerService.getSingleton();
const logChannel = 'common/kompendiumReducer';

/**
 * The initial values
 */
const initialState = Imm.fromJS({
    // Maps kompKey -> loading counter
    loading: {},

    // Maps kompKey -> list of parId
    parMap: {},

    // Maps parId -> paragraph data
    paragraphs: {},
});

/**
 * The actual reducer
 */
export function kompendiumReducer(state: any = initialState, action: any = {}) {
    switch (action.type) {
        case LOAD_KOMPENDIUM_PARAGRAPHS.pending:
            return loadKompendiumParagraphsPending(state, action);
        case LOAD_KOMPENDIUM_PARAGRAPHS.success:
            return loadKompendiumParagraphsSuccess(state, action);
        case LOAD_KOMPENDIUM_PARAGRAPHS.failure:
            return loadKompendiumParagraphsFailure(state, action);
    }

    return state;
}

function loadKompendiumParagraphsPending(state: Imm.Map<string, any>, action: ILoadKompendiumParagraphsAction) {
    return incCounter(state, ['loading', action.meta.kompKey]);
}

function loadKompendiumParagraphsSuccess(state: Imm.Map<string, any>, action: ILoadKompendiumParagraphsAction) {
    const list = Imm.fromJS((action && action.payload && action.payload.List) || []);
    let parIdList = Imm.List<string>();

    list.forEach((item: Imm.Map<string, any>, idx: number) => {
        const parId = `${action.meta.kompKey}_${idx}`;
        parIdList = parIdList.push(parId);
        state = state.setIn(['paragraphs', parId], item);
    });

    state = state.setIn(['parMap', action.meta.kompKey], parIdList);
    return decCounter(state, ['loading', action.meta.kompKey]);
}

function loadKompendiumParagraphsFailure(state: Imm.Map<string, any>, action: ILoadKompendiumParagraphsAction) {
    Log.warn(logChannel, 'Loading Kompendium paragraphs failed!');
    return decCounter(state, ['loading', action.meta.kompKey]);
}
